module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "normal-width": "90vw",
      "width": "960px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [(_vm.SITE_CONFIG.accomodations.show_site) ? _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stopper($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.params.locationId),
      expression: "params.locationId"
    }],
    class: 'map-background map-background--' + _vm.params.locationId + ' type--' + _vm.params.type,
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.params.locationId),
      expression: "params.locationId"
    }],
    staticClass: "center"
  }, [(_vm.params.map_link) ? _c('a', {
    staticClass: "button white small border map-bt",
    attrs: {
      "target": "_blank",
      "href": _vm.params.map_link
    }
  }, [_c('icon', {
    attrs: {
      "name": "map",
      "scale": 2
    }
  }), _vm._v(" Se områdeskarta\n        "), _c('icon', {
    staticClass: "dowload-icon",
    attrs: {
      "name": "download",
      "scale": 1.5
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.params.locationId && _vm.params.type === 'interactive'),
      expression: "params.locationId && params.type === 'interactive'"
    }],
    staticClass: "center",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [(_vm.params.locationId === 2006) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.setLocation(2006, true)
      }
    }
  }, [_vm._v("\n        Sök på alla områden på Branäsberget\n      ")]) : _vm._e(), _vm._v(" "), (_vm.params.locationId === 2007) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.setLocation(2007, true)
      }
    }
  }, [_vm._v("\n        Sök på alla områden i Branäsdalen\n      ")]) : _vm._e(), _vm._v(" "), (_vm.params.locationId === 2020) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.setLocation(2020, true)
      }
    }
  }, [_vm._v("\n        Sök på alla områden i Mattesdalen\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.params.locationId),
      expression: "!params.locationId"
    }]
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_c('icon', {
    attrs: {
      "name": "berget",
      "scale": 1.5
    }
  }), _vm._v(" Branäsberget")], 1), _vm._v(" "), _c('p', [_vm._v("I Branäsbergets stugor och lägenheter får du en fantastisk utsikt över dalen och närhet till skidåkning, pulkabackar och längdspår. Uppe på berget finns skiduthyrning, shop, livsmedelsbutik och restauranger.")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.openMap(2006)
      }
    }
  }, [_vm._v("Karta över Branäsberget")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h2', [_c('icon', {
    attrs: {
      "name": "byn",
      "scale": 1.5
    }
  }), _vm._v(" Branäsdalen")], 1), _vm._v(" "), _c('p', [_vm._v("I Branäsdalen finns både lägenheter och större fjällstugor, med nära till allt du behöver. I Branäsdalen har du nära till skiduthyrning, restaurang, shop och en livsmedelsbutik.")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.openMap(2007)
      }
    }
  }, [_vm._v("Karta över Branäsdalen")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h2', [_c('icon', {
    attrs: {
      "name": "mattesdalen",
      "scale": 1.5
    }
  }), _vm._v(" Mattesdalen")], 1), _vm._v(" "), _c('p', [_vm._v("I Mattesdalen finns både lägenheter och större, moderna fjällstugor. Bor du här har du nära till både 4-stolslift och 6-stolslift som snabbt tar dig upp till toppen och resten av skidområdet.")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.openMap(2020)
      }
    }
  }, [_vm._v("Mattesdalen")])])])]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.accomodations.show_site) ? _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stopper($event)
      }
    }
  }, [_c('div', {
    class: 'map-background map-background--' + _vm.SITE_CONFIG.site + ' type--' + _vm.params.type,
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0411511a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/MapModalbranas.vue
// module id = 900
// module chunks = 0